import { getFilials } from "../../redux/actions";
import {getRequestStates} from "../../redux/actions/requestStateActions";
import { filialDivisionCRUD } from "../../http";

export const contractRequestSearchFields = [
    {
        title: "ID",
        key: "id",
        compareType: "equals",
        operandPosition:1,
        filterType:"normal"
    },
    {
        title: "Номер",
        key: "number",
        compareType: "like",
        operandPosition:1,
        filterType:"normal"
    }
];

const setAdvancedFilterValue = (stateObject, key, val) => {
    if (!val) {
        if (stateObject.advancedFilter) {
            delete stateObject.advancedFilter[key];
            if (Object.keys(stateObject.advancedFilter).length === 0) {
                delete stateObject.advancedFilter;
            }
        }
        return;
    }

    stateObject.advancedFilter = {
        ...(stateObject.advancedFilter || {}),
        [key]: val,
    };
};

export const contractRequestClientFilterFields = [
    {
        title: "Наименование заказчика",
        key: "clientName",
        compareType: "like",
        operandPosition: 1,
        type: "text",
        filterType: "normal",
        get: (searchValue) => searchValue?.advancedFilter?.clientName ?? "",
        set: (stateObject, val) => setAdvancedFilterValue(stateObject, "clientName", val),
    },
    {
        title: "ИИН/БИН заказчика",
        key: "clientIdentityNumber",
        compareType: "like",
        operandPosition: 1,
        type: "text",
        filterType: "normal",
        get: (searchValue) => searchValue?.advancedFilter?.clientIdentityNumber ?? "",
        set: (stateObject, val) => setAdvancedFilterValue(stateObject, "clientIdentityNumber", val),
    },
];

export const contractRequestFilterFields = [
    {
        title: "Cтатус",
        key: "stateId",
        compareType: "equals",
        reducerKey: "requestState",
        reducerArrayKey: "requestStates",
        reducerAction: getRequestStates,
        operandPosition: 1,
        optionLabelKey: "name",
        type: "normal",
        filterType: "normal",
    },
    {
        title: "Филиал",
        key: "filialId",
        compareType: "equals",
        reducerKey: "filial",
        reducerArrayKey: "filials",
        reducerAction: getFilials,
        operandPosition: 1,
        optionLabelKey: "name",
        type: "normal",
        filterType: "normal",
    },
    {
        title: "Районное отделение",
        key: "filialDivisionId",
        compareType: "equals",
        reducerKey: "filialDivision",
        operandPosition: 1,
        parentKey: 'filialId',
        optionLabelKey: "name",
        type: "normal",
        filterType: "normal",
        useDomainSelect2: true,
        domainSelectCrud: filialDivisionCRUD,
        domainSelect2SkipFetchWithoutParent: true,
        domainSelect2NoParentHint: "Выберите филиал",
        selectMembers: ["Id", "Name", "FilialId"],
        normalizeOption: (row) => ({
            ...row,
            id: row.id ?? row.Id,
            name: row.name ?? row.Name,
            filialId: row.filialId ?? row.FilialId,
        }),
    }
]